import { useEffect, useRef } from "react";
import { stepRunId } from "../editStepSummary";
import type { UseStepMark } from "./types";

export const useStepMark: UseStepMark = ({
  steppedTo,
  geometry,
  markRunOnPlan,
}) => {
  const geometryRef = useRef(geometry);
  geometryRef.current = geometry;
  const markRef = useRef(markRunOnPlan);
  markRef.current = markRunOnPlan;

  useEffect(() => {
    if (!steppedTo) return;
    // The geometry AFTER the step, which is what makes a restored device
    // findable at all: before it, the devices coming back are not on the plan.
    const circuitId = stepRunId({
      summary: steppedTo.summary,
      geometry: geometryRef.current,
    });
    // Never `null`: that takes the marks down at once, and a step this cannot
    // point at must leave whatever is up alone.
    if (circuitId) markRef.current(circuitId);
  }, [steppedTo]);
};
